import { css } from 'lit';

export default css`
  :host {
    --private-card-padding-top-bottom: 12px;
  }
  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 133px;
    box-sizing: border-box;
    padding: var(--private-card-padding-top-bottom) 8px;
    border-radius: var(--amityeko-radius-large);

    border: 1px solid var(--amityeko-color-gray-9);
  }

  .card:not(.card--selected):hover {
    background-color: var(--amityeko-color-gray-9);
  }

  .card:not(.card--selected) {
    cursor: pointer;
  }

  .card--selected {
    padding-top: calc(var(--private-card-padding-top-bottom) - 1px);
    padding-bottom: calc(var(--private-card-padding-top-bottom) - 1px);
    border: 2px solid var(--amityeko-color-primary-6);
  }

  .card img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    margin-bottom: 8px;
  }

  amityeko-tg-body-two::part(base) {
    padding-bottom: 4px;
    color: var(--amityeko-color-gray-1);
  }

  .card--selected amityeko-tg-body-two::part(base) {
    color: var(--amityeko-color-primary-6);
  }
`;
